<template>
    <div>
        <v-divider class="mx-0" />
        <v-list-item @click="openResource">
            <v-list-item-content class="mr-3">
                <v-row>
                    <v-col cols="12" class="px-3">
                        <v-list-item-title>
                            <div class="d-flex items-center">
                                <v-tooltip right v-if="notification.tooltip">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon>
                                            <v-icon
                                                :color="
                                                    notification.read
                                                        ? 'primary'
                                                        : ''
                                                "
                                                class="d-flex justify-left ml-n3"
                                            >
                                                {{
                                                    'mdi-information-variant-box'
                                                }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span
                                        class="my-0 text-left"
                                        v-for="(value,
                                        key) in notification.tooltip"
                                        :key="key"
                                    >
                                        {{ key }}: {{ value }}<br />
                                    </span> </v-tooltip
                                ><span class="d-flex align-center text-wrap">{{
                                    notification.message
                                }}</span>
                            </div>
                        </v-list-item-title>
                        <div style="font-size: 13px" class="mt-1">
                            {{ formatDate(notification.createdOn.seconds) }}
                        </div>
                    </v-col>
                </v-row>
            </v-list-item-content>

            <v-list-item-action class="ml-2">
                <v-row>
                    <v-btn
                        v-if="
                            !persistentNotificationIds.includes(
                                notification.reference
                            )
                        "
                        icon
                        @click.stop="changeReadStatus(notification)"
                        :loading="readLoading"
                    >
                        <v-icon>
                            mdi-delete
                        </v-icon>
                    </v-btn>
                </v-row>
            </v-list-item-action>
        </v-list-item>
    </div>
</template>

<script>
import API from '@/services/api'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'NotificationsBell',
    props: {
        notification: {
            type: Object,
            default: () => ({}),
        },
        notificationDocs: {
            type: Object,
            default: () => ({}),
        },
        additionalPersistentNotifications: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            readLoading: false,
            deleteLoading: false,
            alertNotifications: [
                //delete the notification when the user click on it
                'pFDh25EcR74EMiuypq8M', // alert
                'sZhuzxwPqvSsy2wFSK66', // wo pending for approval
                'hg5OuUjeEGVkQyJE19HR', // wo rejected - project manager
                'ar0vX28u4hadZW2pVn9n', // wo closed - project manager
                'IXxoIfPiybErNOxNupac', // receipt rejection in wo item delivery
                'PJtE71kZm6GYMPQVK0mb', // new reprocess wo
                'BvBmJfW6IgAUMKENp3KD', // rejected bom - project manager
                'YxukOCWz1LIH5t4LTfLM', // reserve approved
                'kcq2gZhOuKruTwIoF3CG', // reserve rejected
                'mVzm98xIeAlYeEfdKBdR', // code request approved
                'jVTyA3dpViVt7sJ62z2f', // code request rejected
                'FaaLOdCggYSC0q9Cug86', // purchase send to inTransit - project manager
                'I10UtjGow2PpwMJCEUhb', // purchase send to received
                'ku3RyP09tunIWvAXvunn', // quality release
            ],
            persistentNotifications: [
                // hide trash can button
                '7DihWLWnvZMvh5aHNeEv', // create a lead
                'nVHma9txWN3DeJU3Ax7t', // approve a lead
                'x4KP5EMG94gwjayCVSfv', // new quote assigned to estimator
                'v54UZX76qfydKPyDdhWb', // quote to be requoted - estimator
                'hj42GV1OQ61dojcYyoIn', // quote for approval
                '2TvwiTwXNif7OrJ3CmOv', // scope assigned
                'T4wnlVuEHOUPwMPQkAWl', // scope rejected
                'IRwvcitCKm39nSYhhQqV', // scope engineer assigned
                'sZhuzxwPqvSsy2wFSK66', // wo pending for approval
                '1n6XjrG4WKCLNjZ5WhSL', // approved WO - production planner
                'wu0mfm4lOUmF0G1vdY16', // rejected wo - creator
                'XlXkRVQfI99GydO5F9YF', // rejected bom - creator
                'mqvb8rTWGR8d7Cz6nmrl', // purchase assigned
                'su5V6D7xO01zRfzXLt7E', // purchase send to preApproval
                'CdV17CRxm8tWzZnbxWdd', // purchase send to approval
                'XqRU6KwrWOypCwgHQxbu', // purchase send to purchasing
                'zMQ3cqH7peZ9qMF3xWix', // purchase send to inTransit - creator
                'OTkVRsBdyvICwPoAHUev', // purchase recorded the receipt of material
                '2H20dONa26mK7XFKB6Xt', // HSEQ verification pending for on-site reception
                'oEZbNBsm7NuoohIWRRKo', // invoice
                'AkAPWh7qBWxCfCL12WqN', // create an international invoice
                'WNzjPtOPmiwPEuv0vRc5', // create an local invoice
                '2o3QIGSpJM5Zb1Fpd8jW', // approval invoice
                'z4yw1pMEbJAt5r0oz4FZ', // reject invoice
                '1uT4WecbJ86BTcO7UFIW', // send invoice to a client
                'bgOJPzzceetopCQj5kxs', //  clean invoice
            ],
        }
    },
    computed: {
        ...mapState(['settings']),
        persistentNotificationIds() {
            return [
                ...this.persistentNotifications,
                ...this.additionalPersistentNotifications,
            ]
        },
    },
    methods: {
        ...mapActions(['setNotificationResource']),
        async changeReadStatus() {
            try {
                this.readLoading = true
                // remove a notification
                await API.checkAlertNotification({
                    resourceId: this.notification.resourceId,
                    notificationId: this.notification.reference,
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.readLoading = false
            }
        },

        formatDate(seconds) {
            return moment.unix(seconds).format('DD-MM-YY h:mm a')
        },

        async openResource() {
            const path = this.notification.path
            const currentRoute = this.$route.path
            const resourceId = this.notification.resourceId
            const query = {
                resourceId,
                ...(this.notification.params || {}),
            }
            if (path == '/chat-quote') {
                const {
                    data: { quotes },
                } = await API.getQuote(resourceId)
                this.$emit('openQuote', quotes)
            } else if (currentRoute !== path) {
                this.$router.push({
                    path,
                    query,
                })
            } else {
                this.$router
                    .replace({ path: currentRoute, query })
                    .catch(() => {})
                this.setNotificationResource(resourceId)
            }

            if (this.alertNotifications.includes(this.notification.reference)) {
                // remove a notification
                await API.checkAlertNotification({
                    resourceId: this.notification.resourceId,
                    notificationId: this.notification.reference,
                })
            }
        },
    },
}
</script>
